import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Breadcrumb,
  Dropdown,
  Button,
} from "react-bootstrap";
import {
  FiCalendar,
  FiDownload,
  FiPlus,
  FiChevronUp,
} from "react-icons/fi";
import DatePicker from "react-datepicker";
import { MdKeyboardArrowRight } from "react-icons/md";
import { RiHome6Line } from "react-icons/ri";
import CandidatesAnalysis from "../../../components/Dashboard/recruitment-dashboard/CandidatesAnalysis";
import RecruitmentStatsCards from "../../../components/Dashboard/recruitment-dashboard/RecruitmentStatsCards";
import RecruitmentOverview from "../../../components/Dashboard/recruitment-dashboard/RecruitmentOverview";
import QuickReminder from "../../../components/Dashboard/recruitment-dashboard/QuickReminder";
import AiAssistantCard from "../../../components/Dashboard/recruitment-dashboard/AiAssistantCard";
import AvgTimeToHire from "../../../components/Dashboard/recruitment-dashboard/AvgTimeToHire";
import SchedulesUpcoming from "../../../components/Dashboard/recruitment-dashboard/SchedulesUpcoming";
import StagePerformance from "../../../components/Dashboard/recruitment-dashboard/StagePerformance";
import RecentApplications from "../../../components/Dashboard/recruitment-dashboard/RecentApplications";
import ActiveJobOpenings from "../../../components/Dashboard/recruitment-dashboard/ActiveJobOpenings";

export default function RecruitmentDashboardPage() {
  const [date, setDate] = useState(new Date());

  return (
    <Container fluid className="page-breadcrumb py-3 px-3">
      <Row className="align-items-center justify-content-between flex-wrap">

        {/* LEFT SIDE */}
      <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Recruitment Dashboard</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                           
                          }}
                        />
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                       Dashboard
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Recruitment Dashboard</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT SIDE */}
        <Col md="6" className="d-flex align-items-center justify-content-md-end flex-wrap gap-2">

          {/* DATE PICKER */}
          <div className="date-picker-wrapper">
            {/* <FiCalendar className="icon" /> */}
            <DatePicker
              selected={date}
              onChange={(d) => setDate(d)}
              dateFormat="MMM yyyy"
              showMonthYearPicker
              className="form-control custom-date"
            />
          </div>

          {/* DOWNLOAD DROPDOWN */}
          <Dropdown align="end">
            <Dropdown.Toggle className="btn-white-custom">
              <FiDownload className="me-1" />
              Download Report
            </Dropdown.Toggle>

            <Dropdown.Menu className="custom-dropdown p-2">
              <Dropdown.Item>Daily Report</Dropdown.Item>
              <Dropdown.Item>Weekly Report</Dropdown.Item>
              <Dropdown.Item>Monthly Report</Dropdown.Item>
              <Dropdown.Item>Yearly Report</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          {/* ADD BUTTON */}
          <Button className="btn-gradient">
            <FiPlus /> Add New Job
          </Button>

          {/* COLLAPSE ICON */}
          {/* <div className="collapse-icon">
            <FiChevronUp />
          </div> */}
        </Col>
            <Container fluid className="p-3 dashboard-wrapper">
      <Row>
        <Col xl={8}>
          <CandidatesAnalysis />
          <RecruitmentStatsCards  className="mt-3"/>
        </Col>

        <Col xl={4} className="d-flex flex-column">
          <RecruitmentOverview />
          <QuickReminder className="mt-3" />
        </Col>
      </Row>

      <style>{`
        .dashboard-wrapper .card {
          border-radius: 10px;
          border: 1px solid #eee;
        }

        /* ✅ MOBILE SPACING FIX (<1024px) */
        @media (max-width: 1024px) {
          .dashboard-wrapper .card {
            margin-top: 15px;
          }
        }
      `}</style>
    </Container>
    <Row className="g-3 dashboard-section">

      <Col xl={4}>
        <AiAssistantCard />
      </Col>

      <Col xl={4}>
        <AvgTimeToHire />
      </Col>

      <Col xl={4}>
        <SchedulesUpcoming />
      </Col>

      <style>{`

        /* MOBILE SPACING FIX */
        @media (max-width: 1024px) {
          .dashboard-section .col-xl-4 {
            margin-top: 15px;
          }
        }

      `}</style>

    </Row>

      <Col className="mt-3" >
        <StagePerformance/>
      </Col>

        <Row className="mt-3" >
      <Col lg={4}>
        <RecentApplications />
      </Col>

      <Col lg={8}>
        <ActiveJobOpenings />
      </Col>
    </Row>
        <style>
          {
               `
               .page-breadcrumb {
  background: #f5f6f8;
  border-radius: 8px;
}

/* Title */
.page-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 5px;
}

/* Breadcrumb */
.breadcrumb {
  font-size: 14px;
  color: #6c757d;
}

/* Date Picker */
.date-picker-wrapper {
  position: relative;
}

.date-picker-wrapper .icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.custom-date {
  padding-left: 35px !important;
  height: 38px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  width: 140px;   /* adjust as needed */
  min-width: 120px;
  max-width: 160px;
}

/* Dropdown Button */
.btn-white-custom {
  background: #fff !important;
  border: 1px solid #e5e7eb !important;
  color: #111 !important;
  height: 38px;
  display: flex;
  align-items: center;
}

/* Dropdown Menu */
.custom-dropdown {
  border-radius: 10px;
  min-width: 200px;
}

.custom-dropdown .dropdown-item {
  padding: 10px;
  border-radius: 6px;
}

.custom-dropdown .dropdown-item:hover {
  background: #f3f4f6;
}

/* Gradient Button */
.btn-gradient {
  background: linear-gradient(90deg, #ff6a00, #ff3d00);
  border: none;
  color: #fff;
  height: 38px;
  display: flex;
  align-items: center;
  gap: 5px;
}

/* Collapse Icon */
.collapse-icon {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  cursor: pointer;
}

/* Responsive */
@media (max-width: 768px) {
  .page-title {
    font-size: 18px;
  }

  .btn-gradient {
    width: 100%;
    justify-content: center;
  }
}
               `
          }
        </style>
      </Row>
    </Container>
  );
}